import Vue from 'vue';
import VueI18n from 'vue-i18n'
import elementuiEn from "element-ui/lib/locale/lang/en";
import elementuiZh from "element-ui/lib/locale/lang/zh-CN";
import en from './en'
import zh from './zh'

Vue.use(VueI18n);

const messages = {
    en: Object.assign(en, elementuiEn),
    zh: { ...zh, ...elementuiZh }
}
console.log()
if (!localStorage.getItem('locale')) {
    let lang = navigator.language;
    if (lang === 'zh' || lang === 'zh-CN') {
        localStorage.setItem('locale', 'zh')
    } else {
        localStorage.setItem('locale', 'en')
    }   
}
const i18n = new VueI18n({
    locale: localStorage.getItem('locale') || "zh",
    messages
})

export default i18n;

// 4，如果需要切换中文需要用到locale

// import ElementLocale from 'element-ui/lib/locale'
// ElementLocale.i18n((key, value) => i18n.t(key, value))
// //切换的时候改变this.$i18n.locale的值即可



// WEBPACK FOOTER //
// ./src/lang/index.js